import { Reveal } from "@/components/common/Reveal";

const CHAPTERS = [
  { number: "01", title: "What We Cover", body: "Text goes here" },
  { number: "02", title: "Why Grassroots Football", body: "Text goes here" },
  { number: "03", title: "How To Watch", body: "Text goes here" },
  { number: "04", title: "Join The Community", body: "Text goes here" },
];

export const Manifesto = () => (
  <section data-testid="manifesto-section" className="bg-brand-black py-24">
    <div className="mx-auto max-w-7xl px-6 lg:px-12">
      <Reveal>
        <p className="font-subheading text-xs font-semibold uppercase tracking-[0.3em] text-brand-purple">— The Manifesto —</p>
      </Reveal>

      <div className="mt-10 divide-y divide-border-dark">
        {CHAPTERS.map((chapter, i) => (
          <Reveal key={chapter.number} delay={i * 0.05}>
            <div data-testid={`manifesto-chapter-${chapter.number}`} className="relative grid grid-cols-1 gap-4 py-10 md:grid-cols-12 md:items-center">
              <span
                aria-hidden="true"
                className="pointer-events-none col-span-4 select-none font-heading text-[7rem] leading-none text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.14)] md:text-[9rem]"
              >
                {chapter.number}
              </span>
              <div className="col-span-8 md:col-start-5">
                <h3 className="font-heading text-3xl uppercase text-white sm:text-4xl">{chapter.title}</h3>
                <p className="mt-3 max-w-lg text-white/60">{chapter.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
